<div class="d-flex container-fluid flex-column h-100 py-3">

    <div class="carousel-container">
        <ngb-carousel #carousel [interval]="3000" [showNavigationArrows]="true">
            <ng-template ngbSlide *ngFor="let slide of slides">
                  <div class="carousel-slide">
                    <img [src]="slide" alt="Carousel slide">
                </div>
            </ng-template>
        </ngb-carousel>
    </div>

    <div class="catalogue-container">
        <div class="ai-header">
          <p class="general-text-14">Hello {{userProfile.name}}</p>
          <h1 class="main-question">How can I assist you today?</h1>
          
          <div class="search-input-wrapper">
            <div class="search-input-container">
              <div class="accello-icon-btn" (mousedown)="isActive = true"
              (mouseup)="isActive = false"
              (mouseleave)="isActive = false">
                <img [src]="isActive
                ? 'assets/images/virtusa-icons/add-attachments.svg'
                : 'assets/images/virtusa-icons/add-attachments-light.svg'"  
                />
              </div>
              <input 
                type="text" 
                class="search-input" 
                placeholder="Ask Helio AI a question or make a request..."
                [value]="userQuery"
                (input)="onQueryChange($event)"
                (keydown.enter)="sendQuery()">
              <button class="send-button" (click)="sendQuery()" [disabled]="userQuery === ''">
                <img src="assets/images/virtusa-icons/agentic-send.svg" alt="send" />
              </button>
            </div>
          </div>
        </div>

        <div class="w-100 d-flex flex-row align-items-start justify-content-start py-3" *ngIf="!isLoading">
            <span class="general-text">Start from an example</span>
        </div>
        <div *ngIf="isLoading" class="w-100 v-center my-3 mx-4">
          <app-loading [text]="'Loading chats...'"></app-loading>
        </div>
        <div class="cards-grid" *ngIf="!isLoading">
          <app-generic-card 
            *ngFor="let card of cardItems" 
            [cardData]="card"
            [isLoading]="card.isLoading || false"
            (cardClick)="onCardClick(card)">
          </app-generic-card>
        </div>
      </div>
      
</div>
